import { render, staticRenderFns } from "./Romanza_defaultItem.vue?vue&type=template&id=41f329a4&scoped=true"
import script from "./Romanza_defaultItem.vue?vue&type=script&lang=ts"
export * from "./Romanza_defaultItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f329a4",
  null
  
)

export default component.exports